import { Component, EventEmitter, Input, Output } from '@angular/core';

import { MaterialModule } from '../../../../modules/material.module';
import { SharedModule } from '../../../../modules/shared.module';

@Component({
  selector: 'app-secondary-button',
  standalone: true,
  imports: [SharedModule, MaterialModule],
  templateUrl: './secondary-button.component.html',
  styleUrls: ['./secondary-button.component.scss'],
})
export class SecondaryButtonComponent {
  @Input() text: string;
  @Input() disabled = false;
  @Input() icon: string;
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() type: 'button' | 'submit' = 'button';
  @Input() color: 'secondary' | 'error' = 'secondary';
  @Input() size: 'small' | 'medium' = 'medium';
  @Input() width: 'wrap' | 'full' = 'wrap';
  @Input() analyticsId?: string;

  @Output() clicked = new EventEmitter();

  public click(event: MouseEvent): void {
    this.clicked.emit();
    event.stopPropagation();
  }
}
